if (!customElements.get('wlsn-cart-quantity')) {
  class WLSNCartQuantity extends HTMLElement {
    constructor() {
      super();

      this.lineKey = this.dataset.lineKey;
      this.isLoading = false;

      this.classes = {
        quantitySelector: 'wlsn-quantity-selector',
      };

      this.bindMethods = {
        handleQuantityChange: this._handleQuantityChange.bind(this),
        handleUpdateStart: this._handleUpdateStart.bind(this),
        handleUpdateSuccess: this._handleUpdateSuccess.bind(this),
        handleUpdateError: this._handleUpdateError.bind(this),
      };
    }

    get elements() {
      return {
        quantitySelector: this.querySelector(`${this.classes.quantitySelector}`),
      };
    }

    connectedCallback() {
      this._attachEventListeners();
    }

    disconnectedCallback() {
      this._detachEventListeners();
    }

    _attachEventListeners() {
      const { quantitySelector } = this.elements;
      if (quantitySelector) {
        // Listen to generic quantity:change event from child
        quantitySelector.addEventListener('quantity:change', this.bindMethods.handleQuantityChange);
      }

      // Listen for cart update events from main cart
      document.addEventListener('wlsn:cart:update:start', this.bindMethods.handleUpdateStart);
      document.addEventListener('wlsn:cart:update:success', this.bindMethods.handleUpdateSuccess);
      document.addEventListener('wlsn:cart:update:error', this.bindMethods.handleUpdateError);
    }

    _detachEventListeners() {
      if (quantitySelector) {
        quantitySelector.removeEventListener('quantity:change', this.bindMethods.handleQuantityChange);
      }

      document.removeEventListener('wlsn:cart:update:start', this.bindMethods.handleUpdateStart);
      document.removeEventListener('wlsn:cart:update:success', this.bindMethods.handleUpdateSuccess);
      document.removeEventListener('wlsn:cart:update:error', this.bindMethods.handleUpdateError);
    }

    _handleQuantityChange(event) {
      // Transform generic quantity:change event to cart-specific event
      const { quantity, previousQuantity } = event.detail;
      window.WLSNHelpers.triggerEvent(this, 'wlsn:cart:quantity:change', {
        lineKey: this.lineKey,
        quantity: quantity,
        previousQuantity: previousQuantity,
      });
    }

    _handleUpdateStart(event) {
      const { lineKey, action } = event.detail;
      if (lineKey === this.lineKey && action === 'quantity') {
        this._setLoadingState(true);
      }
    }

    _handleUpdateSuccess(event) {
      const { lineKey } = event.detail;
      if (lineKey === this.lineKey) {
        this._setLoadingState(false);
      }
    }

    _handleUpdateError(event) {
      const { quantitySelector } = this.elements;
      const { lineKey } = event.detail;
      if (lineKey === this.lineKey) {
        this._setLoadingState(false);

        // Reset quantity to previous value if available
        if (quantitySelector && event.detail.cart) {
          const cartItem = event.detail.cart.items.find((item) => item.key === this.lineKey);
          if (cartItem) {
            quantitySelector.setQuantity(cartItem.quantity);
          }
        }
      }
    }

    _setLoadingState(loading) {
      this.isLoading = loading;
      const { quantitySelector } = this.elements;
      if (quantitySelector) {
        quantitySelector.setLoadingState(loading);
      }
    }
  }

  customElements.define('wlsn-cart-quantity', WLSNCartQuantity);
}
